import Home from "./home";
import "./App.css";
import "./fonts/FiraCode-VariableFont_wght.ttf";

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <div className="screen">
          <Home />
        </div>
      </header>
    </div>
  );
}

export default App;
